// extracted by mini-css-extract-plugin
export default {"deleteFilesButtons":"fkod1qoO_qj2lSwwXSEN"};